import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ProductManagement from "./SideBarComponents/productManagementSideBar";
import CustomerManagementSidebar from "./SideBarComponents/customerMangementSidebar";
import StaffManagementSidebar from "./SideBarComponents/staffManagementSideBar";
import AdministrationManagementSidebar from "./SideBarComponents/administration";
import OrderSideBar from "./SideBarComponents/ordersSidebar";
import InventoryManagementSideBar from "./SideBarComponents/purchaseSidebar";
import TableManagementSideBar from "./SideBarComponents/tableManagementSideBar";
import SettingManagementSidebar from "./SideBarComponents/settingManagement";
import ReportManagementSidebar from "./SideBarComponents/reportManagementSideBar";
import GoFatafatSidebar from "./SideBarComponents/goFatafatSidebar";
import { hasSectionAccess } from "../../utils/permissions";

function SidebarNav() {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  return (
    <div className="menu mt-0">
      <div className="menu-header">Navigation</div>

      {/* Dashboard */}
      {hasSectionAccess(user, "dashboard") && (
        <div
          className={`menu-item ${location.pathname === "/" || location.pathname.startsWith("/dashboard")
              ? "active"
              : ""
            }`}
        >
          <NavLink to="/dashboard" className="menu-link" end>
            <div className="menu-icon">
              <i className="fa fa-sitemap"></i>
            </div>
            <div className="menu-text">Dashboard</div>
          </NavLink>
        </div>
      )}

      {/* Orders Side Bar */}
      {hasSectionAccess(user, "orders") && <OrderSideBar />}


      {/* Report */}
      {hasSectionAccess(user, "reports") && <ReportManagementSidebar />}

      {/* Staff */}
      {hasSectionAccess(user, "staff") && <StaffManagementSidebar />}

      {/* Customer Management */}
      {hasSectionAccess(user, "customers") && <CustomerManagementSidebar />}

      {/* Product Management */}
      {hasSectionAccess(user, "itemCatalog") && <ProductManagement />}

      {/* Inventory Management (Purchase + moved stock reports) */}
      <InventoryManagementSideBar />


      {/* Table Management */}
      {hasSectionAccess(user, "diningManagement") && <TableManagementSideBar />}

      {/* Go Fatafat (marketplace) — gated by company IsOnlineMarketplaceEnabled */}
      <GoFatafatSidebar />

      {/* Setting Management */}
      {hasSectionAccess(user, "settings") && <SettingManagementSidebar />}

      {/* Administration */}
      {hasSectionAccess(user, "administration") && <AdministrationManagementSidebar />}
    </div>
  );
}

export default SidebarNav;